import Cookies from 'js-cookie'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import {FireTruckOutlined} from '@mui/icons-material'
import Sidebar, {ISidebarItem} from './components/Sidebar/'
import {useAppSelector} from 'store/hooks'
import {Navigate, Outlet, useLocation} from 'react-router-dom'
import { useGetLocationsOptionsQuery } from 'services/locations'
import * as Styles from './PrivateLayout.styles'

function PrivateLayout() {
    const {token} = useAppSelector((state) => state.auth)
    let location = useLocation()
    const { data: locationsResults } = useGetLocationsOptionsQuery({
        limit: 100,
        page: 1
    })

    if (!token) {
        const loginRoute = '/'
        return <Navigate to={loginRoute} state={{from: location}} replace/>
    }

    let locationId = Cookies.get('selectedLocation')
    const selectedGlobalLocation = locationsResults?.locations?.find(l => l.id === locationId);
    const locationName = selectedGlobalLocation?.name;
    const isAllLocationsSelected = !locationId || locationId === 'all';

    const mainAdminMenu: Array<ISidebarItem> = [
        {
            label: 'Dashboard',
            url: '/admin/dashboard',
            icon: <AssessmentOutlinedIcon/>
        },
        {
            label: 'Orders',
            url: '/admin/orders?page=1',
            icon: <DescriptionOutlinedIcon/>
        },
        {
            label: isAllLocationsSelected ? 'Schedule / Locations' : `Schedule / Location ${locationName || ''}`,
            url: isAllLocationsSelected ? '/admin/locations?page=1' : `/admin/locations/${locationId}`,
            icon: <LocationOnOutlinedIcon/>
        },
        {
            label: 'Trucks',
            url: '/admin/trucks?page=1',
            icon: <FireTruckOutlined/>
        },
        {
            label: 'Customers',
            url: '/admin/customers?page=1',
            icon: <PeopleAltOutlinedIcon/>
        },
        // },
        // {
        //   label: 'Reports',
        //   url: '/admin/reports?page=1',
        //   icon: <SignalCellularAltOutlinedIcon />
        // },
        {
            label: 'Settings',
            url: '/admin/settings?page=1',
            icon: <SettingsOutlinedIcon/>
        }
    ]

    const adminFooterMenu: Array<ISidebarItem> = []

    return (
        <Styles.PageContainer>
            <Sidebar mainMenu={mainAdminMenu} footerMenu={adminFooterMenu}/>
            <Styles.Main>
                <Outlet/>
            </Styles.Main>
        </Styles.PageContainer>
    )
}

export default PrivateLayout
